var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLocation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 52,
    viewBox: "0 0 44 52",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.75 21.5C41.75 36.6667 21.875 49.6667 21.875 49.6667C21.875 49.6667 2 36.6667 2 21.5C2 16.3283 4.09397 11.3684 7.82125 7.71142C11.5485 4.05446 16.6038 2 21.875 2C27.1462 2 32.2015 4.05446 35.9287 7.71142C39.656 11.3684 41.75 16.3283 41.75 21.5Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 28C25.5339 28 28.5 25.0899 28.5 21.5C28.5 17.9101 25.5339 15 21.875 15C18.2161 15 15.25 17.9101 15.25 21.5C15.25 25.0899 18.2161 28 21.875 28Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/location.1abeca5c.svg";
export { ForwardRef as ReactComponent };